<template>
  <article
    class="container-paymentdetailcard my-plan-card"
    :class="{ 'card-notclickable': !($slots.actions || buttons.length) }"
  >
    <div>
      <!-- 임시 -->
      <div class="flex-btw">
        <h4 class="card-title mb-4">{{ title }}</h4>
        <button
          type="button"
          class="cancel-btn"
          v-if="title !== 'Free' && subscriptionStore.currentPlanStatus !== 'CANCEL'"
          @click="handleCancel"
        >
          {{ t('self_service_subscription_cancel') }}
        </button>
      </div>

      <div>
        <slot></slot>
      </div>
    </div>

    <div class="plan-card-btn-wrap pdt-7" v-if="$slots.actions || buttons.length">
      <div class="btn-flex">
        <button
          v-for="(btn, index) in buttons"
          :key="index"
          :class="`l-btn ${btn.type === 'payment' ? 'grident-btn' : 'gray-btn'}`"
          @click="btn.onClick"
        >
          {{ btn.label }}
        </button>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { useModalSurvey } from '@/composables/domains/self-service/useModalSurvey';
import { useSubscriptionStore } from '@/stores/subscription';
import { IButtonDynamic } from '@/types/components';

const subscriptionStore = useSubscriptionStore();

const { setTypeSurveyUnsubscribe, openModalSurvey } = useModalSurvey();

withDefaults(
  defineProps<{
    title: string;
    description?: string;
    buttons: IButtonDynamic[];
  }>(),
  {
    description: '',
  }
);

const { t } = useI18n();

const handleCancel = () => {
  setTypeSurveyUnsubscribe();
  openModalSurvey();
  return;
};
</script>

<style scoped lang="scss">
.my-plan-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.plan-card-btn-wrap {
  display: flex;
  justify-content: flex-end;
  gap: $size-s;
  .btn-flex {
    display: flex;
    justify-content: flex-end;
    gap: $size-s;
    flex-wrap: wrap;
  }
  button {
    padding: 0 24px;
    width: auto;
  }
  @include respond-to(mobile-portrait) {
    .btn-flex {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      button {
        width: 100%;
        font-size: $font-size-psmall;
        word-break: break-all;
      }
    }
  }
}
@include respond-to(mobile-landscape) {
  .container-paymentdetailcard {
    .plan-card-btn-wrap {
      flex-direction: column;
      .flex-center {
        justify-content: flex-end;
      }
    }
  }
}

.cancel-btn {
  border-bottom: 1px solid $color-gray-200;
  color: $color-gray-200;
  font-size: $font-size-psmall;
}
</style>
